module.exports = __webpack_public_path__ + "static/media/hitPlane1.90718a38.wav";